import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapBonusLogFromServer = getDataMapper({
    id: mapField("id", Number),
    amount: mapField("amount", Number),
    comment: mapField("comment"),
    createdAt: mapField("created_at"),
    createdUserId: mapField("created_user_id"),
});

export const mapBonusLogsFromServer = mapArray(mapBonusLogFromServer);
